import { create } from 'zustand';
import { CategoryResponse } from '../types/categories';

export const useDataStore = create((set) => ({
  data: null,
  setData: (newData: CategoryResponse[]) => set({ data: newData }),
}));
